import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownloadIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M31.1948 39.0244H8.02574C6.35734 39.0244 5 37.6671 5 35.9987V4.02574C5 2.35734 6.35734 1 8.02574 1H24.163C24.4458 1 24.7192 1.13196 24.8983 1.34876L34.0226 12.5845C34.1546 12.7542 34.23 12.9616 34.23 13.1784V35.9987C34.23 37.6671 32.8727 39.0244 31.2043 39.0244H31.1948ZM8.02574 2.8852C7.3942 2.8852 6.8852 3.3942 6.8852 4.02574V35.9987C6.8852 36.6302 7.3942 37.1393 8.02574 37.1393H31.1948C31.8264 37.1393 32.3354 36.6302 32.3354 35.9987V13.5083L23.7106 2.8852H8.02574Z"
                fill="currentColor"
            />
            <path
                d="M33.2212 14.1869H24.2853C23.6349 14.1869 23.0977 13.6591 23.0977 13.0087V2.20652C23.0977 1.68809 23.5218 1.26392 24.0403 1.26392C24.5587 1.26392 24.9829 1.68809 24.9829 2.20652V12.3018H33.2117C33.7302 12.3018 34.1543 12.7259 34.1543 13.2444C34.1543 13.7628 33.7302 14.1869 33.2117 14.1869H33.2212Z"
                fill="currentColor"
            />
            <path
                d="M19.3088 32.7279C18.7904 32.7279 18.3662 32.3037 18.3662 31.7853V18.0327C18.3662 17.5143 18.7904 17.0901 19.3088 17.0901C19.8272 17.0901 20.2514 17.5143 20.2514 18.0327V31.7853C20.2514 32.3037 19.8272 32.7279 19.3088 32.7279Z"
                fill="currentColor"
            />
            <path
                d="M19.3092 32.7279C19.0735 32.7279 18.8285 32.6336 18.6494 32.4545C18.2818 32.0869 18.2723 31.4931 18.6494 31.1254L24.0599 25.6489C24.4275 25.2813 25.0213 25.2719 25.389 25.6489C25.7566 26.0166 25.766 26.6104 25.389 26.978L19.9784 32.4545C19.7899 32.643 19.5543 32.7373 19.3092 32.7373V32.7279Z"
                fill="currentColor"
            />
            <path
                d="M19.3187 32.7279C19.0737 32.7279 18.8286 32.6336 18.6495 32.4451L13.239 26.9686C12.8714 26.601 12.8808 25.9977 13.239 25.6396C13.6066 25.2719 14.2004 25.2814 14.568 25.6396L19.9786 31.1161C20.3462 31.4837 20.3368 32.0869 19.9786 32.4451C19.7995 32.6242 19.5544 32.7185 19.3187 32.7185V32.7279Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownloadIcon
